import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button, Icon, Row, Col } from 'antd';
import { getIn } from 'formik';

function ArrayInput(props) {
  const { field, form, label, innerLabel, minLen, ...restProps } = props;

  let error = getIn(form.errors, field.name);

  // if (Array.isArray(error)) {
  //   error = error[0];
  // }

  const touched = getIn(form.touched, field.name);
  const hasError = error !== undefined && !!touched;
  const isValid = !error && !!touched;

  const { name, value } = field;

  const handleChange = (valueItem, index) => {
    const newValue = value ? [...value] : [];

    newValue[index] = valueItem;
    form.setFieldValue(name, newValue);
  };

  const handleRemove = index => {
    const newValue = value.filter(
      (valueItem, valueIndex) => valueIndex !== index
    );
    form.setFieldValue(name, newValue);
    form.setFieldTouched(name, false);
  };

  const handleAdd = () => {
    const newValue = value ? [...value, ''] : [''];
    form.setFieldValue(name, newValue);
    form.setFieldTouched(name, false);
  };

  return (
    <Form.Item
      validateStatus={hasError ? 'error' : undefined}
      hasFeedback={isValid}
      label={label}
      help={(hasError && <li>{error}</li>) || (isValid && '')}
    >
      {value &&
        value.map((valueItem, index) => (
          <Row style={{ marginBottom: 12 }} key={index}>
            <Col span={20}>
              <Input
                value={valueItem}
                onChange={e => handleChange(e.target.value, index)}
                onBlur={() => {
                  form.setFieldTouched(name, true);
                }}
                placeholder={innerLabel}
                {...restProps}
              />
            </Col>
            <Col span={4}>
              {minLen <= index && (
                <Button onClick={() => handleRemove(index)}>
                  <Icon type="delete" />
                </Button>
              )}
            </Col>
          </Row>
        ))}
      <Row style={{ marginBottom: 12 }}>
        <Col span={20}>
          <Button onClick={handleAdd}>
            <Icon type="plus" />
          </Button>
        </Col>
      </Row>
    </Form.Item>
  );
}
ArrayInput.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  label: PropTypes.string,
  innerLabel: PropTypes.string,
  minLen: PropTypes.number
};
export default ArrayInput;
